import React from "react";
import { AutocompleteField, FormItem } from "@tiny/components";

interface CustomTextArrayValueProps {
  prefixName: string;
  disabled?: boolean;
}

function CustomTextArrayValue(props: CustomTextArrayValueProps) {
  const { prefixName, disabled } = props;
  const name = `${prefixName}.value.value`;

  return (
    <FormItem
      name={name}
      rules={{
        required: {
          value: true,
          message: "Required field",
        },
      }}
      watchValue
    >
      <CustomTextArrayField disabled={disabled} />
    </FormItem>
  );
}

interface CustomTextArrayFieldProps {
  value?: string[];
  onChangeValue?: (value: string[]) => void;
  helperText?: string;
  error?: boolean;
  inputRef?: React.ForwardedRef<HTMLInputElement>;
  disabled?: boolean;
}

function CustomTextArrayField(props: CustomTextArrayFieldProps) {
  const { value, onChangeValue, helperText, error, inputRef, disabled } = props;
  const [internalValue, setInternalValue] = React.useState<string[]>(
    value || []
  );

  const changeValue = (v: string[]) => {
    setInternalValue(v);
    onChangeValue?.(v);
  };

  return (
    <AutocompleteField
      inputRef={inputRef}
      placeholder={!(internalValue || value) || "Type and press Enter"}
      freeSolo
      multiple
      options={[]}
      value={internalValue || value}
      onChangeValue={changeValue}
      getOptionLabel={(option) => option}
      limitTags={3}
      helperText={helperText}
      error={error}
      showHelperTextMargin
      disabled={disabled}
    />
  );
}

export default CustomTextArrayValue;
